import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatTable } from '@angular/material/table';
import { Escenario } from 'app/main/models/escenario.model';
import { DimensionRiesgo } from 'app/main/models/dimension-riesgo.model';
import { Probabilidad } from 'app/main/models/probabilidad.model';
import { Impacto } from 'app/main/models/impacto.model';
import { ObjetivoRiesgo } from 'app/main/models/objetivo-riesgo.model';
import { EstructuraJerarquica } from 'app/main/models/estructura-jerarquica.model';
import { NodoEstructuraJerarquica } from 'app/main/models/nodo-estructura-jerarquica.model';
import { AnalisisResidual} from 'app/main/models/analisis-residual.model';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import { ControlService } from 'app/main/services/control.service';
import { Control } from 'app/main/models/control.model';
import { DialogBoxComponent } from 'app/main/apps/control/dialog/dialog-box.component';
const Parser = require('expr-eval').Parser;
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {MatAutocompleteTrigger} from '@angular/material/autocomplete';
import {MatSnackBar} from '@angular/material/snack-bar';


@Component({
  selector: 'app-dialog-box',
  templateUrl: './add-a-residual-dialog-box.component.html',
  styleUrls: ['./add-a-residual-dialog-box.component.scss']
})
export class AddAResidualDialogBoxComponent {

  action: string;
  new_line_p: AnalisisResidual = {id:null,control:null,nodo:null, nodoNombre:null ,estructura:null, nodoEstructuraNombre:null ,costo:'',esfuerzo:'',clasificacion:'',exposicion:0,impacto:null,probabilidad:null};

  dataSource: AnalisisResidual[] = [];
  dataSourceOriginal: AnalisisResidual[] = [];
  objetivoRiesgo : ObjetivoRiesgo = null;
  objetivoRiesgoOriginal : ObjetivoRiesgo = null;
  escenario : Escenario = null;
  probabilidad : Probabilidad = null;
  dimensiones: DimensionRiesgo[] = [];
  dimension: DimensionRiesgo = null;
  controles: Control[] = [];
  control : Control = null;
  estructura: EstructuraJerarquica = null;
  nodo: NodoEstructuraJerarquica = null;
  indexE: number = -1;
  tieneAnalisisIhnerente=true;

  tiposClasificacion = ['Inaceptable','Atención'];
  displayedColumns: string[] = ['control','estructura','nodo','costo','esfuerzo','probabilidad','impacto','exposicion','clasificacion','action'];

  lastTypedControl:string ="";
  myControl = new FormControl();
  filteredControles: Observable<Control[]>;

  @ViewChild('tableProbabilidad', {static: true}) tableProbabilidad: MatTable<any>;
  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;

  constructor(
    public dialog: MatDialog,
    public controlService: ControlService,
    public dialogRef: MatDialogRef<AddAResidualDialogBoxComponent>,
    private _snackBar: MatSnackBar,

    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.action = data.objetivoRiesgo.action;
    this.objetivoRiesgo = data.objetivoRiesgo;
    this.objetivoRiesgoOriginal = JSON.parse(JSON.stringify(data.objetivoRiesgo));
    this.escenario = data.escenario;
    this.dimensiones = data.dimensiones;
    this.estructura = data.estructura;
    this.nodo = data.nodo;
    this.new_line_p.estructura = data.estructura;
    this.new_line_p.nodo = data.nodo;
    this.countControles();
    this.tieneAnalisisIhnerente = this.objetivoRiesgo.topAnalisisInherente.impacto!=null;

    this.escenario.probabilidades.sort((a, b) => (a.valor > b.valor) ? 1 : -1);

  }

  countControles():void{

    this.objetivoRiesgo.cantidadControles = 0;
    this.objetivoRiesgo.analisisResidual.forEach(element => {
      if(element.control!=null && element.control!="")
        this.objetivoRiesgo.cantidadControles +=1;
    });

  }

  doAction(): void{

    this.objetivoRiesgo.topAnalisisResidual = null;
    for(var i=0; this.objetivoRiesgo.analisisResidual.length>i;i++){

      if(this.objetivoRiesgo.topAnalisisResidual == null || this.objetivoRiesgo.topAnalisisResidual.exposicion ==0 ||
          this.objetivoRiesgo.analisisResidual[i].exposicion< this.objetivoRiesgo.topAnalisisResidual.exposicion)
          this.objetivoRiesgo.topAnalisisResidual = this.objetivoRiesgo.analisisResidual[i];
    }
    this.dialogRef.close({event: this.action, data: this.objetivoRiesgo});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel',data: this.objetivoRiesgoOriginal});
  }


  remove(probabilidad: any,index:number): void {

    this.objetivoRiesgo.analisisResidual.splice(index, 1);
    this.objetivoRiesgo.analisisResidual =[...this.objetivoRiesgo.analisisResidual];
    this.countControles();

  }


  addLine():void{

    var error = false;
    if(this.objetivoRiesgo.analisisResidual == undefined){
      this.objetivoRiesgo.analisisResidual = [];
    }

    this.new_line_p.control = this.control.nombre;

    if(this.indexE>=0){
        if(this.objetivoRiesgo.analisisResidual.length==1 && this.objetivoRiesgo.analisisResidual[0].nodo==null){
          //this.objetivoRiesgo.analisisResidual[0] = this.new_line_p;
          var calculoAInherenteNuevo = this.updateProbabilidad(this.new_line_p);
          this.objetivoRiesgo.analisisResidual[0] = calculoAInherenteNuevo;

        }else{
          var calculoAInherenteNuevo = this.updateProbabilidad(this.new_line_p);
          if(calculoAInherenteNuevo.exposicion<= this.objetivoRiesgo.topAnalisisInherente.exposicion){
            this.objetivoRiesgo.analisisResidual[this.indexE].control = this.new_line_p.control;
            this.objetivoRiesgo.analisisResidual[this.indexE].estructura = this.new_line_p.estructura;
            this.objetivoRiesgo.analisisResidual[this.indexE].nodoEstructuraNombre = this.new_line_p.estructura?.nombre;
            this.objetivoRiesgo.analisisResidual[this.indexE].nodo = this.new_line_p.nodo;
            this.objetivoRiesgo.analisisResidual[this.indexE].nodoNombre = this.new_line_p.nodoNombre;
            this.objetivoRiesgo.analisisResidual[this.indexE].costo = this.new_line_p.costo;
            this.objetivoRiesgo.analisisResidual[this.indexE].esfuerzo = this.new_line_p.esfuerzo;
            this.objetivoRiesgo.analisisResidual[this.indexE].impacto = this.new_line_p.impacto;
            this.objetivoRiesgo.analisisResidual[this.indexE].probabilidad = this.new_line_p.probabilidad;
            //this.objetivoRiesgo.analisisResidual[this.indexE].dimension = this.new_line_p.dimension;
            this.objetivoRiesgo.analisisResidual[this.indexE] = calculoAInherenteNuevo;
            //this.objetivoRiesgo.analisisResidual[this.indexE] = this.updateProbabilidad(this.objetivoRiesgo.analisisResidual[this.indexE]);
          }else{
            error = true;
              this.openSnackBar("La exposición residual no pude superar a la inherente.","Cerrar");
              //alert("La exposición residual no pude superar a la inherente.");

          }
      }
    }


    if (this.indexE==-1) {

      this.new_line_p.control = this.new_line_p.control;
      this.new_line_p.nodo = this.new_line_p.nodo;
      this.new_line_p.nodoNombre = this.new_line_p.nodo?.nombre;
      this.new_line_p.estructura = this.new_line_p.estructura;
      this.new_line_p.nodoEstructuraNombre = this.new_line_p.estructura?.nombre;
      this.new_line_p.costo = this.new_line_p.costo;
      this.new_line_p.esfuerzo = this.new_line_p.esfuerzo;
      this.new_line_p.impacto = this.new_line_p.impacto;
      this.new_line_p.probabilidad = this.new_line_p.probabilidad;
      //this.new_line_p.dimension = this.new_line_p.dimension;
      this.new_line_p = this.updateProbabilidad(this.new_line_p);
      if(this.new_line_p.exposicion<= this.objetivoRiesgo.topAnalisisInherente.exposicion){
        this.objetivoRiesgo.analisisResidual.push(this.new_line_p);
      }else{
        error = true;
          this.openSnackBar("La exposición residual no pude superar a la inherente.","Cerrar");
          //alert("La exposición residual no pude superar a la inherente.");
      }
    }

    if(!error){
      this.tableProbabilidad.renderRows();
      this.new_line_p = {id:null,control:null,nodo:this.nodo,estructura:this.estructura,nodoNombre:this.nodo.nombre,nodoEstructuraNombre:this.estructura.nombre,costo:'',esfuerzo:'',clasificacion:'',exposicion:0,impacto:null,probabilidad:null};
      this.countControles();
      this.control = null;
      this.indexE = -1;
      this.filteredControles = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    }
  }

  edit(probabilidad:any,indexO:number):void{
    // Add our fruit
    this.indexE = indexO;

    var controlSelect = null;
    this.controles.forEach(element => {
      if(element.nombre === probabilidad.control)
        controlSelect = element;
    });
    this.control = controlSelect;
    this.new_line_p = {id:probabilidad.id,
                        probabilidad: probabilidad.probabilidad,
                        control:probabilidad.control,
                        estructura: probabilidad.estructura || this.estructura,
                        nodo: probabilidad.nodo || this.nodo,
                        nodoEstructuraNombre: probabilidad.estructura?.nombre || this.estructura?.nombre,
                        nodoNombre: probabilidad.nodo?.nombre || this.nodo?.nombre,
                        costo: probabilidad.costo,
                        esfuerzo: probabilidad.esfuerzo,
                        //dimension:probabilidad.dimension,
                        impacto: probabilidad.impacto,
                        exposicion: probabilidad.exposicion,
                        clasificacion: probabilidad.clasificacion};

    this.countControles();
  }

  probabilidadChange():void{

    var recalculadas: AnalisisResidual[] = [];
    var agregar: boolean = true;
    for(var i=0; this.objetivoRiesgo.analisisResidual.length>i;i++){

      var recalculo = this.updateProbabilidad(this.objetivoRiesgo.analisisResidual[i]);
      if(recalculo.exposicion<= this.objetivoRiesgo.topAnalisisInherente.exposicion){
        recalculadas.push(recalculo);
      }else{
          this.openSnackBar("La exposición residual no pude superar a la inherente.","Cerrar");

          //alert("La exposición residual no pude superar a la inherente.");
        agregar=false;
        break;
      }
    }

      if(agregar)
        this.objetivoRiesgo.analisisResidual = recalculadas;

  }

  updateProbabilidad(analisisResidual):AnalisisResidual{

    var clonado:AnalisisResidual = new AnalisisResidual(analisisResidual);
    const parser = new Parser();
    var expression = parser.parse(this.escenario.formulaDeExposicion);
    var exposicion = expression.evaluate({ P: clonado.probabilidad.valor, I: clonado.impacto.valor });
    clonado.exposicion = exposicion;

    var clasificacion = "Aceptable";
    if(exposicion>=this.escenario.apetito)
      clasificacion = "Atención";

      if(exposicion>=this.escenario.tolerancia)
        clasificacion = "Inaceptable";

    clonado.clasificacion = clasificacion;

    return clonado;
  }

  openDialog(): void {

    const dialogRef = this.dialog.open(NodeSelectorDialogBoxComponent, {
      width: '100%',
      data: {estructura:this.estructura,action:'ADD'},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.new_line_p.nodo = result.data.nodo;
      this.new_line_p.estructura = result.data.estructura;

    });
  }


  ngOnInit(): void {
    this.controlService.getAll(0,1000).pipe().subscribe(req => {
      this.controles = req.body.map( control => {
        console.log(control);
        return {
          id: control.id,
          nombre: control.nombre,
          categoria: control.categoria
        };
      });

      this.filteredControles = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );
    });
  }

  private _filter(value: String): Control[] {
      if(typeof value === "string"){
        const filterValue = value.toLowerCase();
        this.lastTypedControl = value;
        return this.controles.filter(option => option.nombre.toLowerCase().includes(filterValue));
      }
      //return this.controles.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);

  }

  /*
  displayFn(value?: Control) {
    return value ? this.controles.find(_ => _.id === value.id).nombre : undefined;
  }*/

  displayFn(value?: Control) {
    var retorno = "";
    if(value!=null && typeof value=="object")
      retorno = this.controles.find(_ => _.id === value.id).nombre;
    if(value!=null && typeof value=="number")
        retorno = this.controles.find(_ => _.id === value).nombre;
    return retorno;
  }

   public agregarControl():void{
     const dialogRef = this.dialog.open(DialogBoxComponent, {
       width: '100%',
       data: {obj:{nombre:this.lastTypedControl},action:'Add',dataSource:this.controles,autocomplete:false},
       disableClose: true
     });

     dialogRef.afterClosed().subscribe(result => {
       this.controles = [...result.dataSource];
       this.control = result.data;
       this.new_line_p.control = result.data.nombre;
       this.autocomplete.closePanel();

     });
  }

  cleanIfNotControl($event){
    console.log($event);
    if(this.control.id == null)
      this.myControl.setValue("");
  }

  compareObjects(o1: any, o2: any): boolean {
    var equals = false;
    if(o1!=null && o2!=null && typeof o1 === 'object' &&  typeof o2 === 'object' && 'id' in o1 && 'id' in o2 && o1.id === o2.id){
      equals = true;
    }else{
      equals = (o1 == o2)? true:false;
    }

    return equals;
  }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 3000,
        });
    }


}
